import React, { useEffect } from "react";

import PayPalBtn from "./PayPalBtn";

import { createCalendarEvent } from "../constants/api-methods";

export const PayPalPopup = ({
  date,
  start,
  end,
  producer,
  eventInfo,
  bookingInfo,
}) => {
  console.log(bookingInfo);

  return (
    <div className="popup">
      <h1 className="email-title">
        <div className="email-copy --span --top">
          {bookingInfo.session_type} Session
        </div>
        <div className="email-copy --small">
          {` ${date
            .toString()
            .slice(0, 15)} from ${start} to ${end} with ${producer}`}
        </div>

        <svg
          className="titleImg --small"
          width="372"
          height="294"
          viewBox="0 0 372 294"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M317.924 64.51C321.564 69.6959 321.766 77.1579 318.651 86.4596C315.543 95.7379 309.196 106.639 300.092 118.469C281.89 142.119 252.81 169.294 217.159 194.356C181.508 219.419 146.1 237.578 117.695 246.693C103.487 251.252 91.0861 253.53 81.3102 253.308C71.5096 253.087 64.5637 250.365 60.9234 245.179C57.2831 239.993 57.0806 232.531 60.1961 223.23C63.3037 213.951 69.6506 203.05 78.7554 191.22C96.9573 167.57 126.037 140.396 161.688 115.333C197.339 90.2706 232.747 72.1113 261.152 62.9967C275.36 58.4375 287.761 56.1596 297.537 56.3809C307.337 56.6027 314.283 59.3241 317.924 64.51Z"
            stroke="#D8E75F"
            stroke-width="2"
          />
          <path
            d="M310.798 48.5681C314.439 53.754 314.641 61.216 311.526 70.5177C308.418 79.796 302.071 90.6974 292.967 102.527C274.765 126.177 245.685 153.352 210.034 178.414C174.383 203.477 138.975 221.636 110.57 230.751C96.3615 235.31 83.9611 237.588 74.1852 237.366C64.3846 237.145 57.4387 234.423 53.7984 229.237C50.1581 224.051 49.9556 216.589 53.0711 207.288C56.1787 198.01 62.5256 187.108 71.6304 175.278C89.8323 151.628 118.912 124.454 154.563 99.3912C190.214 74.3287 225.622 56.1694 254.027 47.0548C268.235 42.4956 280.636 40.2177 290.412 40.439C300.212 40.6608 307.158 43.3823 310.798 48.5681Z"
            stroke="#D8E75F"
            stroke-width="2"
          />
        </svg>
      </h1>
      <div className="email-copy --span">
        Subtotal:{" "}
        {formatter.format(bookingInfo.hourly_price * bookingInfo.duration)}
      </div>
      <div className="rule --center"></div>

      <div className="paypal-popup">
        {/* <div className="title-ctn">
          <p>{`Book ${date
            .toString()
            .slice(0, 15)} from ${start} to ${end} with ${producer}`}</p>
        </div> */}

        <div className="paypal-ctn">
          <PayPalBtn bookingInfo={bookingInfo} />
        </div>
      </div>
    </div>
  );
};

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export default PayPalPopup;
